import { render, staticRenderFns } from "./Nutzungsbedingungen.vue?vue&type=template&id=11586b0c&scoped=true"
import script from "./Nutzungsbedingungen.vue?vue&type=script&lang=js"
export * from "./Nutzungsbedingungen.vue?vue&type=script&lang=js"
import style0 from "./Nutzungsbedingungen.vue?vue&type=style&index=0&id=11586b0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11586b0c",
  null
  
)

export default component.exports